const DECIMAL_SEPARATOR = /[,.]/;
const DIGIT = /^[0-9]$/;

export const hasDecimalSeparator = (raw: string): boolean => DECIMAL_SEPARATOR.test(raw);

export const isDecimalSeparatorKey = (key: string): boolean => DECIMAL_SEPARATOR.test(key);

export const parseDecimalInput = (raw: string): number | undefined => {
  if (raw.trim() === '') {
    return undefined;
  }
  const parsed = Number(raw.replace(',', '.'));
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const sanitizeDecimalInput = (raw: string): string => {
  let seen = false;
  let result = '';
  for (const char of raw) {
    if (DIGIT.test(char)) {
      result += char;
    } else if (isDecimalSeparatorKey(char) && !seen) {
      seen = true;
      result += char;
    }
  }
  return result;
};
